import bodyHandler from "./bodyHandler";

export default function Navigation({ navToggleId, mobileNavigationId }) {
  const navToggle = document.querySelector(navToggleId);
  const mobileNav = document.querySelector(mobileNavigationId);

  if (!navToggle) {
    throw new Error(
      `Could not find the 'navToggleId' (${navToggleId}) element`
    );
  }
  if (!mobileNav) {
    throw new Error(
      `Could not find the 'mobileNavigationId' (${mobileNavigationId}) element`
    );
  }

  /**
   * Handle navigation click event for open and close
   * @param {string} toggleActiveClassName
   * @param {string} mobileNavigationActiveClassName
   */
  const mobileNavToggleHandler = (
    toggleActiveClassName,
    mobileNavigationActiveClassName
  ) => {
    navToggle.addEventListener("click", () => {
      if (navToggle.classList.contains(toggleActiveClassName)) {
        navToggle.classList.remove(toggleActiveClassName);
        mobileNav.classList.remove(mobileNavigationActiveClassName);
        bodyHandler.open();
        return;
      }

      navToggle.classList.add(toggleActiveClassName);
      mobileNav.classList.add(mobileNavigationActiveClassName);
      bodyHandler.lock();
    });
  };

  /**
   * Handle click on submenu
   * @param {object}
   */
  const submenuNavToggleHandler = ({
    mainNavClassName,
    mainNavActiveState,
    subnavActiveState,
  }) => {
    const navWithSubitems = document.querySelectorAll(mainNavClassName);
    Array.from(navWithSubitems).forEach((subnav) => {
      subnav.addEventListener("click", (e) => {
        e.preventDefault();
        const sub = e.target.nextElementSibling;
        e.target.classList.toggle(mainNavActiveState);
        sub.classList.toggle(subnavActiveState);

        /**
         * Listen for clicks outside the open navigation
         * @param {*} evt
         */
        const handleClickOutside = (evt) => {
          let targetElement = evt.target; // clicked element

          do {
            if (targetElement == sub || targetElement == e.target) {
              return;
            }
            // Traverse the DOM elements - reverse
            targetElement = targetElement.parentNode;
          } while (targetElement);

          // Outside the menu
          sub.classList.remove(subnavActiveState);
          e.target.classList.remove(mainNavActiveState);

          // Remove event when nav is closed
          document.removeEventListener("click", handleClickOutside);
        };

        document.addEventListener("click", handleClickOutside);
      });
    });
  };

  return {
    mobileNavToggleHandler: mobileNavToggleHandler,
    submenuNavToggleHandler: submenuNavToggleHandler,
    scrollingBehavior: () => bodyHandler.scrolling(),
  };
};
